module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/core-js/modules/_iter-step.js
// module id = ../../../../core-js/modules/_iter-step.js
// module chunks = 0